import { useEffect } from 'react';

interface Props {
    element: HTMLElement;
    callback: () => void | null;
}

export const useDetectElementChange = ({ element, callback }: Props) => {
    useEffect(() => {
        if (!callback || !element) {
            return;
        }

        const mutationObserver = new MutationObserver(callback);
        mutationObserver.observe(element, {
            characterData: true,
            childList: true,
            subtree: true
        });

        let resizeObserver: ResizeObserver | undefined;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(element);
        }

        return () => {
            mutationObserver.disconnect();
            resizeObserver?.disconnect();
        };
    }, [callback, element]);
};
